// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"5cf5d959","280":"7b6a24bc","294":"8958af44","497":"40ad9aa1","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};